import _asyncToGenerator from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _createClass from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/home/circleci/project/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { AnalyticsConsentError } from '../types/errors';
import { logger } from './logger';
import { ValidationError } from './validation/validation-error';
/**
 * Thrown when a load should be cancelled.
 */
export var AbortLoadError = /*#__PURE__*/function (_AnalyticsConsentErro) {
  _inherits(AbortLoadError, _AnalyticsConsentErro);
  var _super = _createSuper(AbortLoadError);
  function AbortLoadError(loadSegmentNormally) {
    var _this;
    _classCallCheck(this, AbortLoadError);
    _this = _super.call(this, 'AbortLoadError', '');
    _this.loadSegmentNormally = loadSegmentNormally;
    return _this;
  }
  return _createClass(AbortLoadError);
}(AnalyticsConsentError);
export var LoadToken = /*#__PURE__*/_createClass(function LoadToken(options) {
  _classCallCheck(this, LoadToken);
  this.options = options;
});
export var LoadContext = /*#__PURE__*/function () {
  function LoadContext() {
    _classCallCheck(this, LoadContext);
    this.isAbortCalled = false;
    this.isLoadCalled = false;
    this.abortLoadOptions = {
      loadSegmentNormally: true
    };
    this.loadOptions = {
      /**
       * Opt-in consent
       */
      consentModel: 'opt-in'
    };
  }
  /**
   * Allow analytics.js to be initialized with the consent wrapper.
   * Note: load just means 'allowed to load' -- we still wait for analytics.load to be explicitly called.
   */
  _createClass(LoadContext, [{
    key: "load",
    value: function load(options) {
      this.isLoadCalled = true;
      this.loadOptions = _objectSpread(_objectSpread({}, this.loadOptions), options);
      logger.debug('ctx.load called', this.loadOptions);
    }
    /**
     * Abort the _consent-wrapped_ analytics.js initialization
     */
  }, {
    key: "abort",
    value: function abort(options) {
      this.isAbortCalled = true;
      this.abortLoadOptions = _objectSpread(_objectSpread({}, this.abortLoadOptions), options);
      logger.debug('Abort consent wrapper', this.loadOptions);
    }
  }, {
    key: "validate",
    value: function validate() {
      if (this.isAbortCalled && this.isLoadCalled) {
        throw new ValidationError('both abort and load should not be called');
      }
    }
  }]);
  return LoadContext;
}();
/**
 * Wrapper for shouldLoadSegment fn
 */
export var normalizeShouldLoadSegment = function normalizeShouldLoadSegment(shouldLoadSegment) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var loadCtx;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          loadCtx = new LoadContext();
          _context.next = 3;
          return shouldLoadSegment === null || shouldLoadSegment === void 0 ? void 0 : shouldLoadSegment(loadCtx);
        case 3:
          loadCtx.validate();
          return _context.abrupt("return", loadCtx);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};